import React from 'react'

type Props = {
    title?: string
}

export default function Login({title}: Props) {
  return (
    <div>Login</div>
  )
}